module.exports = __webpack_public_path__ + "staticesp/media/logo.bb63e3d7.svg";